/** "Kích nét" in section 1 of both modes (under the photo): the price on the button, then what happened. */
import { EDIT } from "../messages";
import type { Sharpen } from "./useSharpen";

interface Props {
  sharpen: Sharpen;
  /** the mode's photo is the sharpened one */
  sharpened: boolean;
  /** the mode works on several photos (the editor's batch): one photo at a time */
  batch?: boolean;
  disabled?: boolean;
  onSend: () => void;
}

export function SharpenBox({ sharpen, sharpened, batch = false, disabled = false, onSend }: Props) {
  const msg = sharpen.message;
  return (
    <div className="sharpen-box">
      <h3>{EDIT.sharpen.title}</h3>
      <p className="hint">{EDIT.sharpen.intro}</p>
      <button type="button" className="btn" onClick={onSend}
              disabled={disabled || sharpen.busy || sharpen.running || sharpened || batch}>
        {sharpen.busy ? EDIT.sharpen.busy : EDIT.sharpen.button(sharpen.cost)}
      </button>
      {sharpened ? <p className="hint ok">{EDIT.sharpen.already}</p> : batch && <p className="hint">{EDIT.sharpen.batchOff}</p>}
      {msg && (msg.error ? <p role="alert" className="error">{msg.text}</p> : <p role="status" className="ok">{msg.text}</p>)}
    </div>
  );
}
